import { render } from "./Details.vue?vue&type=template&id=2345aa18"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__